<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">รหัส Promotion</label>
              <label class="col-lg-4">
                <input
                  type="text"
                  class="form-control"
                  v-model="model.promotion_id"
                  v-on:keyup.enter="onFilter()"
              /></label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ชื่อ Promotion</label>
              <label
                class="col-form-label col-lg-8"
                v-if="model.display_name.th != ''"
                ><span class="badge-lang">TH</span
                >{{ model.display_name.th }}</label
              >
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2"></label>
              <label
                class="col-form-label col-lg-8"
                v-if="model.display_name.en != ''"
                ><span class="badge-lang">EN</span
                >{{ model.display_name.en }}</label
              >
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">วันที่ Promotion</label>
              <label class="col-form-label col-lg-8">
                {{ promotion_start_date }} ถึง
                {{ promotion_end_date }}
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">สถานะ</label>
              <label class="col-form-label col-lg-8">
                <span
                  class="ml-2 label"
                  :class="'label-' + model.status.toLowerCase()"
                  v-html="model.status"
                ></span
              ></label>
            </div>
            <div class="form-group mb-4 text-right" v-if="isSearchPromotion">
              <div class="button-items">
                <b-dropdown text="Add Product" variant="success">
                  <template slot="button-content"
                    >Add Product<i class="mdi mdi-chevron-down"></i
                  ></template>
                  <b-dropdown-item
                    @click="
                      toggleSideBar = !toggleSideBar
                      modeAddProduct = 'Import Excel'
                    "
                    >Import Excel
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="
                      toggleSideBar = !toggleSideBar
                      modeAddProduct = 'Add Product'
                    "
                    >Add Product
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <h4 class="card-title mb-4" v-if="isSearchPromotion">
              Product
            </h4>
            <div class="row" v-if="isSearchPromotion">
              <div class="col-sm-12 col-md-6"></div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="searchProduct"
                      type="search"
                      placeholder="Search"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="row" v-if="isSearchPromotion">
              <div class="col-sm-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="productTable"
                    :empty-text="'ไม่พบข้อมูล'"
                    :show-empty="productItems.length == 0"
                    :bordered="true"
                    :filter="searchProduct"
                    :items="productItems"
                    align="center"
                    v-bind:fields="fields"
                    :perPage="perPage"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ (firstRowOnPage + data.index) | number }}
                      </div>
                    </template>
                    <template v-slot:cell(inventory_status)="data">
                      <span
                        v-if="data.value"
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(sale_status)="data">
                      <span
                        v-if="data.value"
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(is_vat)="data">
                      <span
                        v-if="data.value"
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(absorb_description)="data">
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="text-center">
                        <a
                          @click="onDeleteProduct(data.item.id)"
                          class="btn btn-ico text-danger"
                          ><i class="bx bx-trash"></i
                        ></a>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-6">
                <div class="text-left">
                  <div class="button-items">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="onCancel()"
                    >
                      <i
                        class="bx bx-arrow-back font-size-16 align-middle mr-2"
                      ></i>
                      Back
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="text-right">
                  <div class="button-items">
                    <button
                      type="button"
                      class="btn btn-primary"
                      v-if="productItems !== null && productItems.length > 0"
                      @click="onSubmit()"
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      v-if="productItems !== null && productItems.length > 0"
                      @click="onConfirmReset()"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <sideBar
      ref="sideBar"
      :toggleSideBar="toggleSideBar"
      :modeAddProduct="modeAddProduct"
      :listProductItems="productItems"
      @hidden="toggleSideBar = false"
      @getDataSideBar="getDataSideBar"
    ></sideBar>
    <!-- end row -->
  </div>
</template>

<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import { FormatDate, FormatDateTime } from '@/helpers/utils/format-date.js'

import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import productSalePricePromotionService from '@/helpers/service/product-sale-price-promotion-service'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import moment from 'moment'
import sideBar from '@/components/product-sale-price-promotions/sideBar'
import { BasicSelect } from 'vue-search-select'

export default {
  page: {
    title: 'Edit Sale Price Promotion',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    sideBar,
  },
  data() {
    return {
      isSearchPromotion: false,
      id: '',
      title: 'Edit Sale Price Promotion',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Product Pricing : Sale Price Promotion',
          href: '/product-sale-price-promotions',
        },
        {
          text: 'Edit Sale Price Promotion',
          active: true,
        },
      ],
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'is_vat',
          label: 'สินค้าคิดภาษี (Vat)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_price_include_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาขาย (Including Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'sale_price_promotion_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาขาย Promotion (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'sale_price_promotion_include_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาขาย Promotion (Including Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'promotion_gp_rate',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'GP Rate Promotion (%)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'absorb_type',
          label: 'Absorb Type',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'vendor_absorb',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'Vendor Absorb',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'merchandise_absorb',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'Merchandise Absorb',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'marketing_absorb',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'Marketing Absorb',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'product_remark',
          label: 'หมายเหตุการปรับราคา',
          tdClass: 'text-left',
        },
        {
          key: 'error_message',
          label: 'Error Message',
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      perPage: 9999,
      firstRowOnPage: 1,
      productItems: [],
      toggleSideBar: false,
      modeAddProduct: '',
      searchProduct: null,
      pageNo: 1,
      pageSize: 99999,
      model: {
        id: null,
        promotion_id: '',
        display_name: {
          th: '',
          en: '',
        },
        promotion_start_date: '',
        promotion_end_date: '',
        status: '',
        products: [],
      },
      promotion_start_date: '',
      promotion_end_date: '',
    }
  },
  watch: {
    productItems: {
      handler: function(val) {
        val.forEach(element => {
          if (element.is_error) {
            element._rowVariant = 'danger'
          } else {
            element._rowVariant = ''
          }
        })
      },
      deep: true,
    },
  },
  mounted: function() {
    if (this.$route.query.promotion_id !== undefined) {
      this.model.promotion_id = this.$route.query.promotion_id
      // this.$refs.promotion_id.click()
      this.$nextTick(() => this.onFilter())
    }
  },
  methods: {
    onCancel() {
      this.$router.push({
        path: '/product-sale-price-promotions',
      })
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            location.reload()
            // this.isSearchPromotion = false
            // this.productItems = []
            // this.model = {
            //   id: null,
            //   promotion_id: '',
            //   display_name: {
            //     th: '',
            //     en: '',
            //   },
            //   promotion_start_date: '',
            //   promotion_end_date: '',
            //   status: '',
            //   products: [],
            // }
            // this.promotion_start_date = ''
            // this.promotion_end_date = ''
          }
        })
    },
    async onFilter() {
      if (this.model.promotion_id) {
        this.productItems = []
        let result = await productSalePricePromotionService.getPromotionPriceWithSalePricePromotionByPromotionIdAsync(
          this.model.promotion_id
        )
        if (result.status === 200) {
          this.model = result.data
          this.promotion_start_date = moment(this.model.promotion_start_date)
            .utcOffset(this.model.promotion_start_date)
            .format('DD/MM/YYYY HH:mm')
          this.promotion_end_date = moment(this.model.promotion_end_date)
            .utcOffset(this.model.promotion_end_date)
            .format('DD/MM/YYYY HH:mm')
          this.productItems = this.model.products
          this.isSearchPromotion = true
          // this.productItems.push(result.data)
        } else if (
          (result.status && result.status === 404) ||
          (result.response && result.response.status === 404)
        ) {
          this.$utils.notification(
            'error',
            'ไม่พบข้อมูลของรหัส Promotion ' + this.model.promotion_id,
            3000
          )
          this.isSearchPromotion = false
          this.productItems = []
          this.model = {
            id: null,
            promotion_id: '',
            display_name: {
              th: '',
              en: '',
            },
            promotion_start_date: '',
            promotion_end_date: '',
            status: '',
            products: [],
          }
          this.promotion_start_date = ''
          this.promotion_end_date = ''
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          this.$utils.notification('error', result.response.data.message, 2000)
          this.isSearchPromotion = false
          this.productItems = []
          this.model = {
            id: null,
            promotion_id: '',
            display_name: {
              th: '',
              en: '',
            },
            promotion_start_date: '',
            promotion_end_date: '',
            status: '',
            products: [],
          }
          this.promotion_start_date = ''
          this.promotion_end_date = ''
        } else {
          this.isSearchPromotion = false
          this.productItems = []
          this.model = {
            id: null,
            promotion_id: '',
            display_name: {
              th: '',
              en: '',
            },
            promotion_start_date: '',
            promotion_end_date: '',
            status: '',
            products: [],
          }
          this.promotion_start_date = ''
          this.promotion_end_date = ''
        }
      }
    },
    async onSubmit() {
      if (this.productItems.some(s => s.is_error == true)) {
        this.$utils.notification(
          'error',
          'ไม่สามารถดำเนินการต่อได้เนื่องจากชุดยังมูลยังมีรายการที่ผิดพลาด',
          3000
        )
      } else {
        this.model.products = this.productItems
        console.log(this.model)
        let result = await productSalePricePromotionService.updateProductSalePricePromotionAsync(
          this.model
        )
        if (result.status && result.status === 204) {
          this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 2000)
          this.$router.push({
            path: '/product-sale-price-promotions',
          })
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
      }
    },
    onDeleteProduct(id) {
      this.productItems.splice(
        this.productItems.findIndex(element => element.id === id),
        1
      )
    },
    onClearProduct() {
      this.productItems = []
    },
    async getDataSideBar(value) {
      value.forEach(element => {
        if (element.has_absorbed == false) {
          element.has_absorbed = 'No'
        }
        if (this.productItems.find(p => p.id === element.id) !== undefined) {
          this.productItems.find(
            p => p.id == element.id
          ).sale_price_promotion_exclude_vat =
            element.sale_price_promotion_exclude_vat
          this.productItems.find(
            p => p.id == element.id
          ).sale_price_promotion_include_vat =
            element.sale_price_promotion_include_vat
          this.productItems.find(p => p.id == element.id).promotion_gp_rate =
            element.promotion_gp_rate
          this.productItems.find(p => p.id == element.id).has_absorbed =
            element.has_absorbed
          this.productItems.find(p => p.id == element.id).absorb_type =
            element.absorb_type
          this.productItems.find(p => p.id == element.id).vendor_absorb =
            element.vendor_absorb
          this.productItems.find(p => p.id == element.id).merchandise_absorb =
            element.merchandise_absorb
          this.productItems.find(p => p.id == element.id).marketing_absorb =
            element.marketing_absorb
          this.productItems.find(p => p.id == element.id).product_remark =
            element.product_remark
        } else {
          this.productItems.push(element)
        }
      })
    },
  },
}
</script>
